// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ModalWrap_wrap__jBW9G","fixed":"ModalWrap_fixed___z_AQ"};